import axios from "axios";
import { getFileHeaders } from "../utils/helper";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";


export const maternityApplicationCreateApi =async(data)=>{
    const callResponse = await axios({
      url: endpoints.maternityCreate,
      method: 'post',
      headers: getHeaders(),
      data,
    })
      .then((response) => response.data)
      .catch((err) => ({ status: 0, response: err.response, code: err.response.status }))
  
    return callResponse        
  }

  export const fetchMaternityApplicationApi =async(params)=>{
    return await axios({
        url: endpoints.maternityFetch,
        method: "GET",
        headers: getHeaders(),
        params,
      })
        .then(response => response.data)
        .catch(err => ({status:0,response:err.response,code:err.response.status}));          
}

export const maternityFetchByIdApi = async (params) => {
    const callResponse = await axios({
      url: endpoints.maternityFetchById,
      method: "GET",
      headers: getHeaders(),
      params,
    })
      .then((response) => response.data)
      .catch((err) => ({status:0,response:err.response,code:err.response.status}))
  
    return callResponse
  }